export const SKILL_RANGE_OPTIONS = [2, 3, 4, 5] as const;
